<h2 mat-dialog-title>{{ "USER_MANAGEMENT.PAYED_ROLE" | translate }}</h2>
<mat-dialog-content class="flex flex-col gap-4 mt-2">
  {{ "USER_MANAGEMENT.PAYED_ROLE_INFO_TEXT" | translate }}
</mat-dialog-content>

<mat-dialog-actions align="end" class="mt-4">
  <button (click)="onCancel()" mat-button >{{ "ACTION.CANCEL" | translate }}</button>
  <button (click)="onConfirm()" mat-flat-button color="warn">
    {{ "USER_MANAGEMENT.ADD_ROLE" | translate }}
  </button>
</mat-dialog-actions>
